import React from 'react'
import LeftIcon from '../../../Assets/Icons/LeftIcon'
import { Link, useNavigate } from 'react-router-dom'
import './banner.css'
export default function Banner() {
     const navigate = useNavigate();
    return (
        <>
            <div className="fd-banner">
                <div className="fd-banner-content">
                    <div className='maxWidth-content'>
                    <Link  onClick={()=>navigate(-1)}>
                        <LeftIcon />
                    </Link>
                    <h1>Field Days</h1>
                    </div>
                </div>
                
            </div>
        </>
    )
}
